import React from 'react';
import Draggable, {DraggableProps} from 'react-draggable';

interface DraggableContainerProps extends Partial<DraggableProps> {
  children: JSX.Element;
}
const DraggableContainer = ({
  children,
  bounds = 'parent',
  ...rest
}: DraggableContainerProps): JSX.Element => {
  return (
    <Draggable bounds={bounds} {...rest}>
      {children}
    </Draggable>
  );
};

export default DraggableContainer;
